export const defaultSvgProps = {
  className: null,
  fillColor: '#53585E',
};
